import { useCallback, useEffect, useRef, useState } from 'react';

export const useFixedToast = (defaultMessage = 'Settings saved successfully!', duration = 3000) => {
  const [toast, setToast] = useState({
    open: false,
    message: defaultMessage,
    variant: 'success',
  });
  const timeoutRef = useRef(null);

  useEffect(() => () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);

  const hideToast = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setToast((prev) => ({ ...prev, open: false }));
  }, []);

  const showToast = useCallback((message = defaultMessage, variant = 'success') => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setToast({ open: true, message, variant });
    timeoutRef.current = setTimeout(() => {
      setToast((prev) => ({ ...prev, open: false }));
    }, duration);
  }, [defaultMessage, duration]);

  return { toast, showToast, hideToast };
};
